import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Car, CarClass } from '../../interfaces/Car';

interface AdministracaoState {
  selectedClasses: CarClass[];
  selectedStatuses: string[];
  selectedPendingStatuses: string[];
  selectedReleaseStatus?: string[];
  carsByPage: Record<number, Car[]>;
  lastSearchQuery: string;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  sortBy: string | null;
  sortOrder: 'asc' | 'desc' | null;
}

const initialState: AdministracaoState = {
  selectedClasses: [],
  selectedStatuses: [],
  selectedPendingStatuses: [],
  selectedReleaseStatus: undefined,
  carsByPage: {},
  lastSearchQuery: '',
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  sortBy: null,
  sortOrder: null,
};

const administracaoSlice = createSlice({
  name: 'administracao',
  initialState,
  reducers: {
    setSelectedClasses(state, action: PayloadAction<CarClass[]>) {
      state.selectedClasses = action.payload;
    },
    setSelectedStatuses(state, action: PayloadAction<string[]>) {
      state.selectedStatuses = action.payload;
    },
    setSelectedPendingStatuses(state, action: PayloadAction<string[]>) {
      state.selectedPendingStatuses = action.payload;
    },
    setSelectedReleaseStatus(state, action: PayloadAction<string[] | undefined>) {
      state.selectedReleaseStatus = action.payload;
    },
    resetFilters(state) {
      state.selectedClasses = [];
      state.selectedStatuses = [];
      state.selectedPendingStatuses = [];
      state.selectedReleaseStatus = undefined;
    },
    setSearchResults(
      state,
      action: PayloadAction<{
        page: number;
        cars: Car[];
        totalItems: number;
        totalPages: number;
      }>
    ) {
      const { page, cars, totalItems, totalPages } = action.payload;
      state.carsByPage[page] = cars;
      state.totalItems = totalItems;
      state.totalPages = totalPages;
    },
    setLastSearchQuery(state, action: PayloadAction<string>) {
      state.lastSearchQuery = action.payload;
    },
    setReduxCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    resetSearchResults(state) {
      state.carsByPage = {};
      state.totalItems = 0;
      state.totalPages = 0;
      state.lastSearchQuery = '';
    },
    setSortOrderRedux(state, action: PayloadAction<{ sortBy: string; sortOrder: 'asc' | 'desc' }>) {
      state.sortBy = action.payload.sortBy;
      state.sortOrder = action.payload.sortOrder;
    },
  },
});

export const {
  setSelectedClasses,
  setSelectedStatuses,
  setSelectedPendingStatuses,
  setSelectedReleaseStatus,
  resetFilters,
  setSearchResults,
  setLastSearchQuery,
  setReduxCurrentPage,
  resetSearchResults,
  setSortOrderRedux,
} = administracaoSlice.actions;

export default administracaoSlice.reducer;
